import { isLangCode } from "./langUtils";
/**
 * Replace the url in address based in the environment variables NEXT_PUBLIC_LINKS_TO_REPLACE and NEXT_PUBLIC_FE_URL
 * Should be called in the server side, right after the request to the wordpress
 * @param url
 * @returns string
 */
export function ReplaceFrontendUrls(url: string, lang?: string) {
  if (!process.env.NEXT_PUBLIC_LINKS_TO_REPLACE) return url;
  const NEXT_PUBLIC_FE_URL = process.env.NEXT_PUBLIC_FE_URL || "";
  const defaultLang = process.env.NEXT_PUBLIC_DEFAULT_LANG || "en";

  // Single domain replacement
  if (NEXT_PUBLIC_FE_URL) {
    const linksToReplace = process.env.NEXT_PUBLIC_LINKS_TO_REPLACE.split(",").map((link: string) => link.trim());

    linksToReplace.forEach((link: string) => {
      // Normalise to a full URL for hostname comparison
      const normalised = link.startsWith('http') ? link : `https://${link}`;
      try {
        const { hostname, protocol } = new URL(normalised);
        // Match http or https variants of this exact hostname (no regex metachar risk)
        const escapedOriginHttp  = `http://${hostname}`;
        const escapedOriginHttps = `https://${hostname}`;
        const feUrlWithoutTrailingSlash = NEXT_PUBLIC_FE_URL.replace(/\/$/, '');
        if (url.startsWith(escapedOriginHttps)) {
          url = feUrlWithoutTrailingSlash + url.slice(escapedOriginHttps.length);
        } else if (url.startsWith(escapedOriginHttp)) {
          url = feUrlWithoutTrailingSlash + url.slice(escapedOriginHttp.length);
        }
      } catch {
        // Malformed entry — skip silently
      }
    });
  }

  // Fix double slashes but preserve protocol
  url = url.replace(/([^:]\/)\/+/g, '$1');

  // Strip default language prefix if present (WPML sometimes adds it)
  if (defaultLang) {
    url = url.replace(new RegExp(`/${defaultLang}/`, 'g'), '/');
    url = url.replace(new RegExp(`/${defaultLang}$`), '');
    url = url.replace(
      new RegExp(`(${NEXT_PUBLIC_FE_URL.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})/${defaultLang}(?=/|$)`),
      '$1'
    );
    url = url.replace(/([^:]\/)\/+/g, '$1');
  }

  // If lang is set and NOT the default, add the language prefix to internal URLs
  // e.g. http://localhost:3000/contacto/ → http://localhost:3000/es/contacto/
  if (lang && lang !== defaultLang && NEXT_PUBLIC_FE_URL) {
    const feBase = NEXT_PUBLIC_FE_URL.replace(/\/$/, '');
    if (url.startsWith(feBase)) {
      const rawPath = url.slice(feBase.length); // e.g. /contacto/
      const pathAfterBase = rawPath.startsWith('/') ? rawPath : `/${rawPath}`;
      const firstSegment = pathAfterBase.split('/').filter(Boolean)[0] || '';
      const isAlreadyLang = isLangCode(firstSegment);
      if (!isAlreadyLang && pathAfterBase !== '/') {
        url = `${feBase}/${lang}${pathAfterBase}`;
      } else if (!isAlreadyLang) {
        url = `${feBase}/${lang}/`;
      }
    }
  }

  return url;
}

/**
 * Replace the urls in the blocks from the wordpress
 * @param blocks blocks from the wordpress
 * @param lang language to translate
 * @returns the blocks with the urls replaced
 */

export async function ReplaceUrlsInBlocks(blocks: any[], lang: string) {
  // for loop to make sure that tasks run syncronous
  for (const block of blocks) {
    //  blocks.forEach(async (block) => {
    if (block.innerBlocks) {
      block.innerBlocks = await ReplaceUrlsInBlocks(block.innerBlocks, lang);
    }
    if (block.blocks) {
      block.blocks = await ReplaceUrlsInBlocks(block.blocks, lang);
    }

    if (block.attrs) {
      block.attrs = await ReplaceUrlsInAttrs(block.attrs, lang);
    }
  }

  return blocks;
}

/**
 * Replace the urls in the attributes from the wordpress
 * @param attrs attributes from the wordpress
 * @param lang language to translate
 * @returns the attributes with the urls replaced
 */
export async function ReplaceUrlsInAttrs(attrs: any, lang: string) {
    if (attrs?.grid?.items && Array.isArray(attrs.grid.items)) {
    for (const gridItem of attrs.grid.items) {
      if (gridItem.slug) {
        gridItem.slug = ReplaceFrontendUrls(gridItem.slug, lang);
      }
    }
  }

  if (attrs?.href?.url) {
    attrs.href.url = ReplaceFrontendUrls(attrs.href.url, lang);
  }
  return attrs;
}
